import React from 'react';

import './CSS/App.css';

import Title from "./components/Title"
import Image from "./components/Image"
import Text from "./components/Text"
function App () {

  
  
  return (
    <div className="App">
        <Title />

        <Image />

        <Text />
        
    </div>

  );
}

export default App;
